import { render, staticRenderFns } from "./deliverydate.vue?vue&type=template&id=08fafdb4&"
import script from "./deliverydate.vue?vue&type=script&lang=js&"
export * from "./deliverydate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports